module.exports = __webpack_public_path__ + "img/yes-check-2.4092779c.svg";